import posthog from 'posthog-js';

const normal_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição Normal' : 'Normal';
const alarm_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição de Alarme' : 'Medio';
const critical_condition = posthog.isFeatureEnabled('is-modec') ? 'Condição Crítica' : 'Alto';
const potential_problem = posthog.isFeatureEnabled('is-modec') ? 'Problema Potencial' : 'Muy Alto';

export const i18nRecordsPage = {
  title: 'Registros',
  add_a_comment: 'Agregar un comentario',
  view_records: 'Ver registros',
  event_records: 'Registros del evento',
  attachments: 'Archivos adjuntos',
  comments: 'Comentarios',
  summary: {
    attachments: 'Archivos adjuntos',
    comments: 'Comentarios',
    last_update: 'Última actualización: ',
  },

  category: {
    generic: {
      comment: 'Comentario',
      attached_file: 'Archivo adjunto',
      detached_file: 'Archivo separado',
      updated: 'Actualizado',
    },

    Alarm: {
      useful: 'Clasificación: Útil',
      not_useful: 'Clasificación: No útil',
      reclassify_useful: 'Reclasificación: Útil',
      reclassify_not_useful: 'Reclasificación: No útil',
    },
    Case: {
      status_updated: 'Actualizado',
      severity_updated: 'Actualizado',
      created: 'Creado',
      owner_updated: 'Actualizado',
      action_created: 'Creado',
      action_updated: 'Actualizado',
      action_deleted: 'Eliminado',
    },

    ConditionDeviation: {
      action_status_updated: 'Estado de acción actualizado',
      severity_updated: 'Gravedad actualizada',
      created: 'Creado',
      updated: 'Actualizado',
    },
  },
  category_message: {
    generic: {
      attached_file: '@{{user_name}} adjunto {{field}}',
      detached_file: '@{{user_name}} separado {{field}}',
      updated: '@{{user_name}} cambió: {{field}}',
    },
    Case: {
      status_updated: '@{{user_name}} estado cambiado para "{{field}}"',
      severity_updated: '@{{user_name}} estado alterado para: {{field}}',
      created: '@{{user_name}} Caso creado por la gravedad {{field}}',
      owner_updated: '@{{field}} Es el nuevo propietario del caso',
      action_created: '@{{user_name}} creó la acción {{field}}',
      action_updated: '@{{user_name}} actualizou {{field}} of "{{name}}"',
      action_deleted: '@{{user_name}} eliminó la Acción {{field}}',
    },
    Alarm: {
      useful: '@{{user_name}} reconoció esta alarma como Útil, {{field}}',
      not_useful: '@{{user_name}} reconoció esta alarma como No útil, {{field}}',
      reclassify_useful: '@{{user_name}} reclasificó esta alarma como Útil, {{field}}',
      reclassify_not_useful: '@{{user_name}} reclasificó esta alarma como No útil, {{field}}',
    },

    ConditionDeviation: {
      action_status_updated: '@{{user_name}} cambió el estado de acción a {{field}}',
      severity_updated: '@{{user_name}} cambió la Gravedad a {{field}}',
      cd_created:
        '@{{user_name}} creó una condición de desviación con el siguiente estado y gravedad, respectivamente: {{field}}',
    },
  },
  values: {
    // classification
    useful: 'Útil',
    not_useful: 'Inútil',

    // action_status
    investigating: 'Investigando',
    action_issued: 'Acción emitida',
    canceled: 'Cancelado',
    under_evaluation: 'En evaluación',
    completed: 'Completado',
    normal_condition,
    alarm_condition,
    critical_condition,
    potential_problem,
    not_monitored: 'No Monitoreado',
    not_operated: 'No Operado',

    // severity
    very_high: 'Muy alta',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
    Information: 'Baja',
    Warning: 'Baja',
    Minor: 'Medium',
    Major: 'Alta',
    Critical: 'Muy alta',
  },
};
